<div class="mb-3" [class.invalid-feedback]="showError">
  <div class="form-control-group">
      <nb-checkbox
        size="small"
        [formControl]="formControl"
        [formlyAttributes]="field"
      >{{ props.placeholder }}
      </nb-checkbox>
  </div>
  @if (showError) {
    <div class="invalid-feedback">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  }
  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }
</div>
